import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { I18nService } from '@app/core';
import { UtilService } from './util.service';
import { CryptographyService } from '@app/cryptography.service'
import { environment } from '@env/environment';

enum ConfigType {
  ApiUrl = 1, 
  CustomApiUrl = 2, 
  LogInUrl = 3, 
  PortalApiUrl = 4, 
  PortalLoginUrl = 5,
  PortalUrl = 6
}

@Injectable()
export class ApiService {
  private API_URL: any;
  private CUSTOM_API_URL: any;
  private ipClient: string;

  constructor(
    private http: Http,
    private route: Router,
    private i18nService: I18nService,
    private util: UtilService,
    private crypto: CryptographyService
  ) { }

  async get(system: string, action: string, queryParam?: string) {
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)
    
    
    let reqObj = {
      m: this.crypto.encrypt("GET", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam) , aesKey),
      s: aesPublic
    }
    
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }

    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async getMasterAddress() {

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/master/address"

    return new Promise(resolve => {
      this.http.get(url).toPromise().then((data) => {
        let res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
        console.error("get address failed.")
      });
    });
  }

  
  async post(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {

    dataObj["dpa_callby"] = '3'

   
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj2 = {
      m: this.crypto.encrypt("POST", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }


  async getPortal(system: string, action: string, queryParam?: string) {
    // let ApiUrl = await this.getConfig(ConfigType.PortalApiUrl);

    // let url = ApiUrl + "/" + system + "/" + action;

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj = {
      route: this.crypto.encrypt("/api/" + system + "/" + action + (queryParam == null ? "" : "?" + queryParam), aesKey),
      s: aesPublic
    }

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/" + system + "/" + action //+ param

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then(async (data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async postPortal(system: string, action: string, dataObj: object) {
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/" + system + "/" + action;

    // let ck: any = JSON.parse(localStorage.getItem("pbk"))
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj: any = { ...dataObj }
    reqObj = this.crypto.encryptDictValue(reqObj, aesKey)
    reqObj["s"] = aesPublic

    return new Promise(resolve => {
      this.http.post(url, reqObj).toPromise().then((data) => {
        if (data["_body"] != null && data["_body"] != "") {
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else {
          resolve(data);
        }
      }).catch((err) => {
        this.util.ShowWaiting(false);
        if (err["_body"] != null && err["_body"] != "") {
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp);
        }
        else {
          resolve(err);
        }
      });
    });
  }

  async put(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {
    dataObj["dpa_callby"] = '3'

    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    let reqObj2 = {
      m: this.crypto.encrypt("PUT", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey)
          resolve(tmp)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async delete(system: string, action: string) {
    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig(ConfigType.ApiUrl);
    }

    if (this.ipClient == undefined || this.ipClient == null) {
      this.ipClient = sessionStorage.getItem("clientIP");
    }

    const url = this.API_URL + '/' + system + '/' + action;

    const header = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + await this.getToken()
    });
    const options = new RequestOptions({ headers: header });

    return new Promise(resolve => {
      this.http.delete(url, options).toPromise().then((data) => {
        if(data["_body"] != null && data["_body"] != ""){
          let res = data.json();
          res = this.crypto.decryptDictValue(res)
          resolve(res);
        }
        else{
          resolve(data)
        }
      }).catch((err) => {
        if(err["_body"] != null && err["_body"] != ""){
          let tmp :any = this.crypto.decryptDictValue(JSON.parse(err["_body"]))
          err["_body"] = JSON.stringify(tmp)
        }
        if (err.statusText == 'OK') {
          resolve(err)
        }
        else {
          resolve(err)
        }
      });
    });
  }

  async getConfig(Type: ConfigType) {
    let configData = '';

    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        if (Type == ConfigType.ApiUrl)
          resolve(this.crypto.decrypt(res.ApiUrl));
        else if (Type == ConfigType.CustomApiUrl)
          resolve(this.crypto.decrypt(res.CustomApiUrl));
        else if (Type == ConfigType.PortalApiUrl)
          resolve(this.crypto.decrypt(res.PortalApiUrl));
        else if (Type == ConfigType.PortalLoginUrl)
          resolve(this.crypto.decrypt(res.PortalLoginUrl));
          else if (Type == ConfigType.PortalUrl)
          resolve(this.crypto.decrypt(res.PortalUrl));
        else
          resolve(this.crypto.decrypt(res.LoginUrl));
      }).catch((err) => {
        this.util.ShowWaiting(false);
        // sessionStorage.setItem('errorMesaage', 'เกิดข้อผิดพลาดบางประการ');
        // this.route.navigate(['/error']);
      });
    });
  }

  async GetPortalLoginUrl() {
    return this.getConfig(ConfigType.PortalLoginUrl);
  }

  async upload(system: string, action: string, dataObj: object) {

    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig(ConfigType.ApiUrl);
    }


    if (this.ipClient == undefined || this.ipClient == null) {
      this.ipClient = sessionStorage.getItem("clientIP");
    }



    const url = 'http://localhost:53675/api/upload/UploadFile';

    return new Promise(resolve => {
      this.http.post(url, dataObj).toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {

      });
    });
  }


  async getIP() {

    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig(ConfigType.ApiUrl);
    }

    var url = this.API_URL + "/ip/GetIp";

    return new Promise(resolve => {
      this.http.get(url).toPromise().then((data) => {
        const res = data.json();
        resolve(res);


      }).catch((err) => {
        this.util.ShowWaiting(false);
      });
    });
  }

  async CheckSession() {
    console.log("CheckSession");
    var result = false;
    if (this.API_URL == undefined || this.API_URL == null) {
      this.API_URL = await this.getConfig(ConfigType.ApiUrl);
    }

    var url = this.API_URL + "/account/GetUserSessionCurrent";

    const header = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + await this.getToken()
    });
    const options = new RequestOptions({ headers: header });
    var dataObj = {};
    dataObj["ip_address"] = this.util.GetCurrIP();
    dataObj["member_no"] = this.util.GetUserID();

    var datapost = {};
    datapost["user"] = this.util.GetUserID();
    datapost["ip"] = this.util.GetClientIP();
    datapost["lang"] = this.i18nService.language;
    datapost["requestData"] = dataObj;

    console.log(url);
    var datares: any = await new Promise(resolve => {
      this.http.post(url, datapost, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
        throw err;
      });
    });


    if (datares != null) {

      if (datares.isSuccess) {
        if (datares.responseData) {
          if (datares.responseData.length > 0) {
            result = true;
          }
        }

      }
    }
    if (!result) {
      sessionStorage.setItem("clientIP", null);
      sessionStorage.setItem("clientUser", null);
      sessionStorage.setItem("member_obj", null);
      var url_login: any = await this.getConfig(ConfigType.LogInUrl);
      window.location.href = url_login;
    }
    return result;
  }

  async postnotauthen(system: string, action: string, dataObj: object, mode?: string, branchID?: string) {

    // if (this.API_URL == undefined || this.API_URL == null) {
    //   this.API_URL = await this.getConfig(ConfigType.ApiUrl);
    // }


    // if (this.ipClient == undefined || this.ipClient == null) {
    //   this.ipClient = sessionStorage.getItem("clientIP");
    // }



    // const url = this.API_URL + '/' + system + '/' + action;

    // const header = new Headers({
    //   'Content-Type': 'application/json',
    //   'Authorization': 'Bearer ' + await this.getToken()
    // });
    // const options = new RequestOptions({ headers: header });

    // // var datahead = {};
    // // datahead["client_ip"] = this.ipClient;
    // // datahead["lang"] = this.i18nService.language;

    // dataObj = this.crypto.encryptDictValue(dataObj)
    // return new Promise(resolve => {
    //   this.http.post(url, dataObj, options).toPromise().then((data) => {
    //     let res = data.json();
    //       res = this.crypto.decryptDictValue(res)
    //       resolve(res);
    //   }).catch((err) => {
    //     this.util.ShowWaiting(false);
    //     if (action == "agentbankLogin") 
    //       return resolve(this.crypto.decryptDictValue(JSON.parse(err["_body"])));
    //     this.util.ErrorDialog('System Error : ' + err);
    //   });
    // });

    // if (this.API_URL == undefined || this.API_URL == null) {
    //   this.API_URL = await this.getConfig();
    // }


    // if (this.ipClient == undefined || this.ipClient == null) {
    //   this.ipClient = localStorage.getItem("clientIP");
    // }

    dataObj["dpa_callby"] = '3'

    //const url = this.API_URL + '/' + system + '/' + action;

    // const header = new Headers({
    //   'Content-Type': 'application/json',
    //   'Authorization': 'Bearer ' + await this.getToken()
    // });
    // const options = new RequestOptions({ headers: header });
    let pbk = await this.keyFromCk()
    let aesKey: any = this.crypto.genAesKey()
    let aesPublic: any = this.crypto.rsaEncrypt(pbk, aesKey)

    // let reqObj: any = { ...dataObj }
    // reqObj = this.crypto.encryptDictValue(reqObj)
    

    let reqObj2 = {
      m: this.crypto.encrypt("POST", aesKey),
      route: this.crypto.encrypt("/" + system + "/" + action, aesKey),
      s: aesPublic,
      req: this.crypto.encrypt(JSON.stringify(dataObj), aesKey)
    }

    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" +environment.apiPort)
    url += "/api/Core/PostApi"

    return new Promise(resolve => {
      this.http.post(url, reqObj2).toPromise().then((data) => {
        let res = data.json();
          res = this.crypto.decryptDictValue(res, aesKey)
          resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
        if (action == "agentbankLogin") 
          return resolve(this.crypto.decryptDictValue(JSON.parse(err["_body"]), aesKey));
        this.util.ErrorDialog('System Error : ' + err);
      });
    });
  }

  async getTokenConfig() {
    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res)
      }).catch((err) => {
        return null
      });
    });
  }

  async getToken() {
    let config: any = await this.getTokenConfig()
    const url = this.crypto.decrypt(config.getTokenUrl)
    let req: any = {
      "username": config.getTokenUser,
      "password": config.getTokenPassword
    }

    const header = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: header });

    return new Promise(resolve => {
      this.http.post(url, req, options).toPromise().then((data) => {
        const res = data.json();
        resolve(res.AccessToken);
      }).catch((err) => {
        if (err.statusText == 'OK') {
          resolve(err)
        }
        else {
          this.util.ShowWaiting(false);
          resolve(null)
          //this.util.ErrorDialog('System Error : ' + err);
        }
      });
    });
  }

  async getKey() {
    let url = ""
    if(environment.apiPort == ""){
      url = this.util.baseUrl() + environment.apiPath
    }
    else{
      url = this.util.baseUrlNoPort() + ":" +environment.apiPort + environment.apiPath
    }
    //let url = this.util.baseUrlNoPort() + (environment.apiPort == "" ? "" : ":" + environment.apiPort)
    url += "/api/" + "Key" + "/" + "GetKey"

    return new Promise(resolve => {
      this.http.get(url).toPromise().then(async (data) =>  {
        let res = data.json();
        resolve(res);
      }).catch((err) => {
        this.util.ShowWaiting(false);
      });
    });
  }

  async keyFromCk(){
    let pbk: any = JSON.parse(localStorage.getItem("pbk"))

    if (pbk != null && pbk != ""){
        return pbk
    }
    else {
      let getKeyRes: any = await this.getKey()
      pbk = getKeyRes
      localStorage.setItem("pbk", JSON.stringify(pbk))
      return getKeyRes;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utility/api.service.ts